import axios from "../axios";

const getBankWithdraw = async function (accessToken) {
    try {
        const response = await axios.get('withdraw-account/getBankWithdraw', {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBankWithdraw;
